import { useEffect } from 'react';
import { useAuth } from '@platform/auth-sdk';
import { initiateLogin, isOAuthCallback } from '@platform/auth-sdk';
import AppRoutes from './router';

const authConfig = {
  identityCenterUrl: import.meta.env.VITE_IDENTITY_CENTER_URL as string,
  clientId: import.meta.env.VITE_CLIENT_ID as string,
  redirectUri: window.location.origin + '/auth/callback',
  audience: import.meta.env.VITE_API_AUDIENCE as string || 'platform-services',
  scope: 'openid profile email',
};

function App() {
  const { isAuthenticated, isLoading } = useAuth();

  useEffect(() => {
    // Don't redirect if we're on the callback page or still loading
    if (isLoading || isOAuthCallback()) return;

    // If not authenticated, redirect to Identity Center login
    if (!isAuthenticated) {
      initiateLogin(authConfig);
    }
  }, [isAuthenticated, isLoading]);

  // Show loading spinner while checking auth
  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-50">
        <div className="text-center">
          <div className="mx-auto h-10 w-10 animate-spin rounded-full border-4 border-indigo-200 border-t-indigo-600" />
          <p className="mt-4 text-sm text-slate-600">Loading TrackDox...</p>
        </div>
      </div>
    );
  }

  // If not authenticated (and not loading), show nothing while redirect happens
  if (!isAuthenticated) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-50">
        <div className="text-center">
          <div className="mx-auto h-10 w-10 animate-spin rounded-full border-4 border-indigo-200 border-t-indigo-600" />
          <p className="mt-4 text-sm text-slate-600">Redirecting to login...</p>
        </div>
      </div>
    );
  }

  return <AppRoutes />;
}

export default App;
